export const galleryLayouts = {
  HORIZONTAL: 'h',
  VERTICAL: 'v',
}

export const galleryTypes = {
  PAID: 'paid_galleries',
  UNLOCKED: 'unlocked_galleries',
}

export const checkinTabs = {
  BUYABLE: 'Buyable',
  BOUGHT: 'Bought'
}

export const cartActions = {
    ADD: 'add',
    REMOVE: 'remove'
}

export const mediaTypes = {
    PHOTO: 'photo',
    VIDEO: 'video'
}

export const ctaPosition = {
    TOP: 't',
    BOTTOM: 'b'
}